import { Contract } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import i18next from 'i18next';
import middleware from 'middleware';
import { useEffect } from 'react';
import {
  useGetPhysicalDistributionSectionTemplate,
  useGetPhysicalDistributionTemplateLightList,
} from 'services/templates/physical-distribution-template';
import { TEMPLATE_TYPE } from 'services/templates/types';
import { addItem, getExtremeId } from 'utils/dnd/dndUtilities';

const ContractSideMenuPhysicalDistribution = () => {
  const { values, setFieldValue, namePrefix, setErrors } = useFormikContractHelpers();

  const physicalDistributionLightList =
    useGetPhysicalDistributionTemplateLightList();

  const selectedId = values.sideMenu?.customTemplate?.selectedId;

  const parentId = values.sideMenu?.customTemplate?.parentId;

  const physicalDistributionTemplate = useGetPhysicalDistributionSectionTemplate(
    selectedId ?? '',
    {
      notFoundPath: undefined,
      notFoundToastError: i18next.t('toast-message.not-found'),
    },
    !!selectedId,
    false
  );

  useEffect(() => {
    if (!!selectedId && physicalDistributionTemplate.data && parentId) {
      const contractTemplateForm = middleware.template.physicalDistribution.queryToForm(
        physicalDistributionTemplate.data,
        `${parseInt(getExtremeId(values.items)) + 1}`
      );

      const physicalDistribution = contractTemplateForm[0].children[0];

      if (contractTemplateForm) {
        setFieldValue(
          namePrefix,
          addItem(values.items, parentId, physicalDistribution)
        );
        setFieldValue('sideMenu', undefined);
        setErrors({})
      }
      console.log(
        'useEffect - physicalDistributionTemplate',
        selectedId,
        physicalDistributionTemplate.data
      );
    }
  }, [selectedId, physicalDistributionTemplate.data]);

  return (
    <Contract.SideMenu.TemplatesList.Wrapper
      templates={physicalDistributionLightList.data}
      templateType={TEMPLATE_TYPE.physicalDistribution}
      item={template => (
        <Contract.SideMenu.TemplatesList.ListItem
          key={template.id}
          template={template}
        />
      )}
    />
  );
};

export default ContractSideMenuPhysicalDistribution;
